import { getQuizzes, getUserById } from '../utils/quiz';
import { useEffect, useState } from 'react';

import Question from '../Question';
import { formatNearAmount } from 'near-api-js/lib/utils/format';
import { useTranslation } from 'react-i18next';
import { useWalletSelector } from '../utils/WalletSelectorContext';

const ViewPage = ({ acc }) => {
  const id = window.location.pathname.split('/').pop();

  const { t, i18n } = useTranslation();

  const [currentQuiz, setCurrentQuiz] = useState(null);

  const [user, setUser] = useState(null);

  const { modal } = useWalletSelector();

  const handleLogin = () => modal.show();

  const getUser = async () => {
    const usr = await getUserById(acc.accountId);
    return usr;
  };

  useEffect(() => {
    const fetchQuiz = async () => {
      const quizzes = await getQuizzes();
      const quiz = quizzes.filter((quiz) => quiz.quizId === id);
      // console.log(quiz[0]);
      setCurrentQuiz(quiz[0]);
    };

    fetchQuiz();

    try {
      getUser().then((u) => setUser(u));
    } catch (e) {
      console.log(e);
    }
  }, [id]);

  if (!acc.accountId)
    return (
      <div className='flex flex-col gap-4 justify-center items-center h-[75vh]'>
        <h1 className='text-4xl font-bold text-gray-700 dark:text-gray-300'>
          You are not logged in
        </h1>
        <button
          title='Login'
          onClick={handleLogin}
          className='inline-flex items-center justify-center mt-3 sm:mt-0 gap-0 py-4 px-6 text-center text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800'>
          Login
        </button>
      </div>
    );

  return (
    <main className='py-16'>
      {currentQuiz ? (
        currentQuiz.createdBy === acc.accountId ? (
          <div className='flex flex-col items-center justify-center gap-3 max-w-3xl mx-auto'>
            <div
              className={
                i18n.language === 'en'
                  ? 'flex flex-col md:flex-row gap-2 mb-4 items-center justify-center md:text-left w-full'
                  : 'flex flex-col md:flex-row-reverse gap-2 mb-4 items-center justify-center md:text-right w-full'
              }>
              <div className='flex flex-col gap-2 mb-4 w-full'>
                <h1 className='text-3xl font-bold'>{currentQuiz?.quizTitle}</h1>
                <h2
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  className='text-xl font-semibold'>
                  {i18n.language === 'ar'
                    ? `معرّف الاختبار: ${currentQuiz?.quizId}`
                    : `Quiz ID: ${currentQuiz?.quizId}`}
                </h2>
                <p className=''>{currentQuiz?.quizDescription}</p>
              </div>
              <div className='flex flex-col gap-2 mb-4 w-full'>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start md:items-start gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'></path>
                  </svg>
                  <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                    {new Date(
                      currentQuiz?.availableFrom / 1000000
                    ).toLocaleDateString(i18n.language, {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </span>
                  {i18n.language === 'ar' ? (
                    <svg
                      className='w-4 h-4 text-primary-500'
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M7 16l-4-4m0 0l4-4m-4 4h18'></path>
                    </svg>
                  ) : (
                    <svg
                      className='w-4 h-4 text-primary-500'
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                      xmlns='http://www.w3.org/2000/svg'>
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M17 8l4 4m0 0l-4 4m4-4H3'></path>
                    </svg>
                  )}
                  <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                    {new Date(
                      currentQuiz?.availableTill / 1000000
                    ).toLocaleDateString(i18n.language, {
                      day: 'numeric',
                      month: 'short',
                      year: 'numeric',
                    })}
                  </span>
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start  gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z'></path>
                  </svg>
                  <span>
                    {i18n.language === 'en'
                      ? `Score ${currentQuiz?.percentageToWin}% or higher to win`
                      : `أجب على ${currentQuiz?.percentageToWin}% أو أكثر للفوز`}
                  </span>
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start  gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'></path>
                  </svg>
                  {currentQuiz?.rewardPerWinner ? (
                    <span>
                      {formatNearAmount(currentQuiz?.rewardPerWinner)} NEAR
                    </span>
                  ) : (
                    <span>{formatNearAmount('0')} NEAR</span>
                  )}
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start  gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7'></path>
                  </svg>
                  {currentQuiz?.rewardPerWinner ? (
                    <span>
                      {i18n.language === 'ar' && 'عدد '}
                      {/* Comparing to self -> Checks NaN values */}
                      {formatNearAmount(currentQuiz?.remainingReward) /
                        formatNearAmount(currentQuiz?.rewardPerWinner) !==
                      formatNearAmount(currentQuiz?.remainingReward) /
                        formatNearAmount(currentQuiz?.rewardPerWinner)
                        ? 0
                        : formatNearAmount(currentQuiz?.remainingReward) /
                          formatNearAmount(currentQuiz?.rewardPerWinner)}
                      {i18n.language === 'en'
                        ? ' prize(s) left'
                        : ' جائزة متبقي'}
                    </span>
                  ) : (
                    <span>
                      {i18n.language === 'en'
                        ? 'No-prize quiz'
                        : 'اختبار بدون جائزة'}
                    </span>
                  )}
                </p>
                <p
                  className={
                    i18n.language === 'ar'
                      ? 'flex flex-row-reverse justify-center items-center md:justify-start  gap-2 w-full'
                      : 'flex justify-center items-center md:justify-start gap-2 w-full'
                  }>
                  <svg
                    className='w-6 h-6 text-primary-500'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15'></path>
                  </svg>
                  <span dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                    {user
                      ? user.quizSubmissions.hasOwnProperty(id)
                        ? currentQuiz?.allowMultipleTrials -
                          user.quizSubmissions[id]?.submittedTimes
                        : currentQuiz?.allowMultipleTrials
                      : currentQuiz?.allowMultipleTrials}
                    {i18n.language === 'en'
                      ? ' attempt(s) left'
                      : ' محاولات متبقية'}
                  </span>
                </p>
              </div>
            </div>
            <hr className='w-full mb-4 dark:opacity-40' />
            <h2
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
              className='text-xl font-semibold border-b-2'>
              {i18n.language === 'en'
                ? `Number of questions: ${currentQuiz?.questions.length}`
                : `عدد الأسئلة: ${currentQuiz?.questions.length}`}
            </h2>
            {currentQuiz?.questions.map((question, idx) => (
              <Question question={question} key={idx} viewOnly />
            ))}
          </div>
        ) : (
          <div
            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            className='text-2xl my-36'>
            <h1 className='font-semibold'>
              {t('take-quiz-error-cant-access')}
            </h1>
            <h2 className='mt-2'>
              {t('take-quiz-error-cant-access-subtitle')}
            </h2>
          </div>
        )
      ) : (
        <div
          dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
          className='text-2xl my-36'>
          <h1 className='font-semibold'>{t('take-quiz-error-title')}</h1>
          <h2 className='mt-2'>{t('take-quiz-error-subtitle')}</h2>
        </div>
      )}
    </main>
  );
};

export default ViewPage;
